import { render, staticRenderFns } from "./BannerForm.vue?vue&type=template&id=7452cbd9&scoped=true"
import script from "./BannerForm.vue?vue&type=script&lang=js"
export * from "./BannerForm.vue?vue&type=script&lang=js"
import style0 from "./BannerForm.vue?vue&type=style&index=0&id=7452cbd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7452cbd9",
  null
  
)

export default component.exports